var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStudentFdRating(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 40,
    viewBox: "0 0 43 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14116",
    "data-name": "Group 14116",
    transform: "translate(-1248 -3872)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14107",
    "data-name": "Group 14107",
    transform: "translate(-29 -1549)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_375",
    "data-name": "Rectangle 375",
    width: 43,
    height: 40,
    rx: 12,
    transform: "translate(1277 5421)",
    fill: "#3488eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13791",
    "data-name": "Group 13791",
    transform: "translate(1254 3875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3964",
    "data-name": "Path 3964",
    d: "M13.959,18a.959.959,0,0,0,0,1.918h9.588a.959.959,0,0,0,0-1.918Z",
    transform: "translate(-5.727 -7.289)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3965",
    "data-name": "Path 3965",
    d: "M13.959,30a.959.959,0,0,0,0,1.918h9.588a.959.959,0,0,0,0-1.918Z",
    transform: "translate(-5.727 -13.536)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3966",
    "data-name": "Path 3966",
    d: "M13.959,42a.959.959,0,1,0,0,1.918h4.794a.959.959,0,1,0,0-1.918Z",
    transform: "translate(-5.727 -19.783)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3967",
    "data-name": "Path 3967",
    d: "M5.835,4A3.835,3.835,0,0,0,2,7.835V27.011a3.835,3.835,0,0,0,3.835,3.835H20.217a3.835,3.835,0,0,0,3.835-3.835V7.835A3.835,3.835,0,0,0,20.217,4ZM3.918,7.835A1.918,1.918,0,0,1,5.835,5.918H20.217a1.918,1.918,0,0,1,1.918,1.918V27.011a1.918,1.918,0,0,1-1.918,1.918H5.835a1.918,1.918,0,0,1-1.918-1.918Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3968",
    "data-name": "Path 3968",
    d: "M51.959,31.134A.959.959,0,0,1,51,30.176V11.959a.959.959,0,1,1,1.918,0V30.176A.959.959,0,0,1,51.959,31.134Z",
    transform: "translate(-25.51 -3.644)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3969",
    "data-name": "Path 3969",
    d: "M58,30.464a.959.959,0,1,0,1.918,0V18.959a.959.959,0,1,0-1.918,0Z",
    transform: "translate(-29.154 -7.289)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentFdRating);
export default __webpack_public_path__ + "static/media/student-fd-rating.0317bf29097f3aef39dca3cf0d55a6dd.svg";
export { ForwardRef as ReactComponent };